import React from 'react'
import clsx from 'clsx'
import type { TableHTMLAttributes } from 'react'

export type Props = TableHTMLAttributes<HTMLTableElement>

const Table: React.FC<Props> = ({ children, className, ...rest }: Props) => {
  const base = 'table'
  const cn = clsx(base, className)

  return (
    <table className={cn} {...rest}>
      {children}
    </table>
  )
}

export default Table
